// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n4uD","textarea":"styles_textarea__2E6f2"};